/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FolderCertIcon16Solid = forwardRef('FolderCertIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 2.5A1.5 1.5 0 0 1 2.5 1h3.3a1.5 1.5 0 0 1 1.205.607L8.037 3H12.5A2.5 2.5 0 0 1 15 5.5v5a2.5 2.5 0 0 1-2 2.45v2.55a.5.5 0 0 1-.8.4l-1.05-.787a.25.25 0 0 0-.3 0L9.8 15.9a.5.5 0 0 1-.8-.4V13H3.5A2.5 2.5 0 0 1 1 10.5v-8Zm10 9.375a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75ZM3 5.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z" })));
});
